import { createContext, Dispatch, SetStateAction } from "react";

import { FormInstance } from "antd";

import { AdditionalDataClient, Client, QuotationClient } from "../../../../../../../shared/interfaces";
import { ClientDataTableGrid } from "../../interfaces";
import { StepOneForm, StepOneFormRepresentative } from "../../../utils";
import { LegalRepresentative } from "../../../../../../../shared/interfaces/services/insert-legal-representative-service";

interface StepOneFormContextProps {
    
    /** List of clients */
    clients:                        Array<Client>;
    setClients:                     Dispatch<SetStateAction<Array<Client>>>;
    
    /** Client selected by the user */
    clientSelected:                 QuotationClient | undefined;
    setClientSelected:              Dispatch<SetStateAction<QuotationClient | undefined>>;

    additionalDataClientSelected:                 AdditionalDataClient | undefined;
    setAdditionalDataClientSelected:              Dispatch<SetStateAction<AdditionalDataClient | undefined>>;

    /** Legal representative selected by the user */
    legalRepresentativeSelected:    LegalRepresentative[] | undefined;
    setLegalRepresentativeSelected: Dispatch<SetStateAction<LegalRepresentative[] | undefined>>
    
    /**  Variable for save fields of the step one form */
    stepOneForm:                    StepOneForm | undefined;
    setStepOneForm:                 Dispatch<SetStateAction <StepOneForm  | undefined>>;
    
    /** List of clients for use in table grid */
    tableClientList:                Array<ClientDataTableGrid>;
    setTableClientList:             Dispatch<SetStateAction<Array<ClientDataTableGrid>>>;

    /** Instance of client data form */
    clientDataForm:                 FormInstance<StepOneForm>;

    /** Instance of client data form */
    legalRepresentativeDataForm:    FormInstance<StepOneFormRepresentative>;

    /** Flag for determine if the modal of client selection is open or not  */
    clientListModalIsOpen:          boolean;
    setClientListModalIsOpen:       Dispatch<SetStateAction<boolean>>;

    /** Flag for determine if the modal of client selection is open or not  */
    isRepresentativeModal:          boolean;
    setIsRepresentativeModal:       Dispatch<SetStateAction<boolean>>;

    /** Flag for determinate if the client list is loading */
    isLoadingClientList:            boolean;

    //* Methods

    /** Method for use when the user select a client in the modal */
    onSelectClientOnTable:      ( codigo: string ) => Promise<void>;
}

export const StepOneFormContext = createContext({} as StepOneFormContextProps);